import { Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import { AppStorage } from '../../../../../Core/Service/storage-service';
import { useState } from 'react';
import './tcardTemplate.scss';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import BuildIcon from '@material-ui/icons/Build';

export const Tcard = ({
    customer,
    registration,
    color,
    isLoanVehicle,
    status,
    date,
    tCardsID,
    handleTcardOpen,
    textColor,
    legendItems,
    hideBookingDate,
    wn,
    vsc,
    days,
    breakdown,
    breakdownStatus,
    breakdownTime
}) => {
    const portalSetting = AppStorage.getPortalSetting();
    // const classes = useStyles();
    const [hovered, setHovered] = useState(false);
    return (
        <div style={{ background: color, height: hideBookingDate ? 35 : '' }} className={'Tcard'} onClick={() => handleTcardOpen(true, tCardsID, false, color)}>
            <Grid container justifyContent="space-between" spacing={0}>
                <Grid
                    item
                    lg={7}
                    style={{
                        display: 'flex',
                        alignItems: 'center', // 👈 keeps everything vertically aligned
                        gap: 4, // small horizontal gap
                        lineHeight: 1 // reduces extra height from inline elements
                    }}
                >
                    <div
                        style={{
                            fontSize: 11,
                            fontWeight: 600,
                            textAlign: 'left',
                            color: textColor,
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {registration}
                    </div>

                    <DriveEtaIcon
                        style={{
                            fontSize: 15,
                            color: vsc || 'grey'
                        }}
                    />

                    <BuildIcon
                        style={{
                            fontSize: 15,
                            color: breakdown ? 'red' : 'grey'
                        }}
                    />

                    {isLoanVehicle && (
                        <div
                            style={{
                                fontSize: 6,
                                fontWeight: 600,
                                background: portalSetting.portalSettingsLoanVehicleBgColor,
                                color: portalSetting.portalSettingsLoanVehicleTextColor,
                                padding: '1px 3px',
                                borderRadius: 2,
                                height: 'fit-content', // 👈 ensures it doesn't stretch the row
                                lineHeight: 1
                            }}
                        >
                            {portalSetting.portalSettingsLoanVehicleText}
                        </div>
                    )}
                </Grid>

                <Grid item lg={1}>
                    <Typography style={{ fontSize: 10, fontWeight: 900, textAlign: 'right', color: textColor }}>{days}</Typography>
                </Grid>
                <Grid item lg={4}>
                    <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'right', color: textColor }}>{wn}</Typography>
                </Grid>

                <Grid item xs={12}>
                    {breakdownTime && breakdownStatus && (
                        <Typography
                            style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor }}
                        >{`Breakdown : (${breakdownTime} Hrs)    ${breakdownStatus}`}</Typography>
                    )}
                    <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor }}>{customer}</Typography>
                </Grid>

                {/* <Grid item xs={12}></Grid> */}
            </Grid>
            <Grid container justifyContent="space-between" alignItems="center">
                {!hideBookingDate && (
                    <Grid item xs={4}>
                        <Typography
                            style={{
                                fontSize: 10,
                                fontWeight: 600,
                                textAlign: 'left',
                                color: textColor
                            }}
                        >
                            {date
                                ? moment(date).hour() === 0 && moment(date).minute() === 0
                                    ? moment(date).format('DD/MM') // if time is 00:00
                                    : moment(date).format('DD/MM HH:mm') // otherwise include time
                                : 'N/A'}
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={12}>
                    {/* {status && ( */}
                    <div style={{ display: 'grid', rowGap: 1, gridTemplateColumns: 'repeat(9, 1fr)', justifyContent: 'start' }}>
                        {legendItems?.map((k) => {
                            if (status[k.st]) {
                                return (
                                    <div key={k.st} style={{ margin: '0px 2px' }}>
                                        <Typography
                                            style={{
                                                fontSize: 8,
                                                fontWeight: 600,
                                                background: k.background,
                                                color: k.color ? k.color : 'white',
                                                padding: 2
                                            }}
                                        >
                                            {k.label}
                                        </Typography>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={k.st} style={{ margin: '0px 2px' }}>
                                        <Typography
                                            style={{
                                                fontSize: 6,
                                                fontWeight: 600,
                                                // background: k.background,
                                                color: 'white',
                                                padding: 2
                                            }}
                                        ></Typography>
                                    </div>
                                );
                            }
                        })}
                    </div>
                    {/* )} */}
                </Grid>
                {status.motloc && (
                    <Grid item xs={12}>
                        <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor }}>
                            {status.motloc} ({moment(status.motdate).format('DD-MM-YYYY HH:mm')})
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};
